import axios from "axios";

const Api = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL
  });
};

const LiveApi = () => {
  return axios.create({
    baseURL: "https://api.nomadrooms.com/"
  });
};

export { Api, LiveApi };
